const url = import.meta.env.VITE_APP_API_TRADE

const TYPE_ISOLATED = 0
const TYPE_CROSS = 1

function addOrder(state, data) {
    state.userOrderList.unshift({
        hash: data.h,
        direction: data.d,
        volume: data.v,
        remain_volume: data.r,
        price: data.p,
        stop_loss: data.s_l,
        take_profit: data.t_p,
        side: data.ot === 0? 'buy' : 'sell',
        date_time: Math.floor(Date.now() / 1000)
    });
}
function deleteOrder(state, index) {
    if(index != -1)
        state.userOrderList.splice(index, 1)
}
function updateOrder(state, data, hash) {
    const index = state.userOrderList.findIndex(e => e.hash == hash)
    if (index === -1) {
        addOrder(state, data)
    } else if(data.r > 0) {
        state.userOrderList[index].remain_volume = data.r
    } else {
        deleteOrder(state, index)
    }
}

function addMarginOrder(state, data, type) {
    state[type].unshift({
        type: 0,
        fee_amount:data.fee,
        hash: data.h,
        direction: data.d,
        investment: data.i,
        leverage: data.lv,
        entry_price: data.ep,
        prev_price: data.cp,
        current_price: data.cp,
        take_profit: data.tp,
        stop_loss: data.sl,
        liquidation_price: data.lp,
        profit: data.p,
        volume: data.vl,
        used_margin: data.um,
        prev_profit: data.p,
        spread: data.s,
        position_type: data.pt,
        trade_type: data.tt,
        status: data.st,
        date_time: data.dt
    });
}

function updateMarginOrder(state, data, index, type) {
    state[type][index].fee_amount = data.fee;
    state[type][index].prev_price = state[type][index].current_price;
    state[type][index].current_price = data.cp;
    state[type][index].take_profit = data.tp;
    state[type][index].stop_loss = data.sl;
    state[type][index].prev_profit = state[type][index].profit;
    state[type][index].profit = data.p;
    state[type][index].liquidation_price = data.lp;
    state[type][index].volume = data.vl;
    state[type][index].entry_price = data.ep;
    state[type][index].position_type = data.pt;
    state[type][index].investment = data.i;
    state[type][index].used_margin = data.um;
    state[type][index].status = data.st;
}

function deleteMarginOrder(state, index, type) {
    if(index != -1)
        state[type].splice(index, 1);
}

function handleMarginOrder(state, data, hash) {
    if(data.st == "new" || data.st == "open" || data.st == "margincall") {
        const indexOpen = state.userMarginOrderOpenList.findIndex(e => e.hash == hash);

        if (indexOpen === -1) {
            addMarginOrder(state, data,'userMarginOrderOpenList');
        } else {
            updateMarginOrder(state, data, indexOpen, 'userMarginOrderOpenList');
        }
    } else  {
        const indexOpen = state.userMarginOrderOpenList.findIndex(e => e.hash == hash);
        if (indexOpen !== -1) {
            deleteMarginOrder(state, indexOpen, 'userMarginOrderOpenList')
        }

        const indexHistory = state.userMarginOrderHistoryList.findIndex(e => e.hash == hash);
        if (indexHistory === -1) {
            addMarginOrder(state, data,'userMarginOrderHistoryList');
        } else {
            updateMarginOrder(state, data, indexHistory, 'userMarginOrderHistoryList');
        }
    }
}

function addDial(state, data) {
    state.userDialList.unshift({
        aggressive_type : data.ot === 0? 'buy' : 'sell',
        my_order_type: data.ot === 0? 'buy' : 'sell',
        direction: data.d,
        fee: data.f,
        volume: data.dv,
        remain_volume: data.r,
        price: data.p,
        date_time: Math.floor(Date.now() / 1000)
    })
}
function updateDial(state, data, hash) {
    const index = state.userDialList.findIndex(e => e.hash == hash)
    if(index === -1) {
        addDial(state, data)
    } else {
        state.userDialList[index].remain_volume = data.r
    }
}


export {TYPE_ISOLATED, TYPE_CROSS}
export default {
    actions: {
        createOrder: async ({ commit, getters, dispatch }, data) => {
            data.direction = getters.getActiveTool.direction
            return dispatch("fetchAuth", {
                url: `${url}/order/add`,
                option: {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                },
                action: {name: "createOrder", data: data},
            }).then(result => result)
        },
        createMarginOrder: async ({ commit, getters, dispatch }, data) => {
            data.direction = getters.getActiveTool.direction
            return dispatch("fetchAuth", {
                url: `${url}/margin-order/add`,
                option: {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                },
                action: {name: "createCrossOrder", data: data},
            }).then(result => result)
        },
        fetchUserDials: async ({ commit, getters, dispatch }) => {
            commit('SET_USER_DIAL_LOADING_STATUS', 'loading')
            const {getActiveTool} = getters

            return dispatch("fetchAuth", {
                //`${url}/order/my-list?status=completed&direction=${getActiveTool.direction}`, //
                url: `${url}/order/my-dials?direction=${getActiveTool.direction}`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "fetchUserDials", data: {}},
            }).then(
                result => {
                    if(result.data.items) {
                        commit('SET_USER_DIAL_LOADING_STATUS', 'success')
                        commit('SET_USER_DIALS', result.data.items)
                    } else  {
                        commit('SET_USER_DIAL_LOADING_STATUS', 'error')
                    }
                },
                error => {
                    commit('SET_USER_DIAL_LOADING_STATUS', 'error')
                }
            )
        },
        
        fetchUserMarginOrdersOpen: async ({ commit, getters, dispatch }) => {
            commit('SET_USER_MARGIN_ORDER_OPEN_LOADING_STATUS', 'loading')
            return dispatch("fetchAuth", {
                url: `${url}/margin-order/my-list?status=open`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "fetchUserMarginOrdersOpen", data: {}}
            }).then(
                result => {
                    if(result.data.items) {
                        const openMarginOrderList = result.data.items;
                        dispatch("fetchAuth", {
                            url: `${url}/margin-order/my-list?status=new`,
                            option: {method: "GET", headers: {"Content-Type": "application/json"}},
                            action: {name: "fetchUserMarginOrdersOpen", data: {}}
                        }).then(
                            result => {
                                if(result.data.items) {
                                    commit('SET_USER_MARGIN_ORDER_OPEN_LOADING_STATUS', 'success')
                                    let combinedArray = openMarginOrderList.concat(result.data.items);
                                    commit('SET_USER_MARGIN_ORDER_OPEN_LIST', combinedArray)
                                } else  {
                                    commit('SET_USER_MARGIN_ORDER_OPEN_LOADING_STATUS', 'error')
                                }
                            },
                            error => {
                                commit('SET_USER_MARGIN_ORDER_OPEN_LOADING_STATUS', 'error')
                            }
                        )
                    } else  {
                        commit('SET_USER_MARGIN_ORDER_OPEN_LOADING_STATUS', 'error')
                    }
                },
                error => {
                    commit('SET_USER_MARGIN_ORDER_OPEN_LOADING_STATUS', 'error')
                }
            )
        },
        fetchUserMarginOrdersHistory: async ({ commit, getters, dispatch }) => {
            commit('SET_USER_MARGIN_ORDER_HISTORY_LOADING_STATUS', 'loading')
            return dispatch("fetchAuth", {
                url: `${url}/margin-order/my-list?status=history`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "fetchUserMarginOrdersHistory", data: {}}
            }).then(
                result => {
                    if(result.data.items) {
                        commit('SET_USER_MARGIN_ORDER_HISTORY_LOADING_STATUS', 'success')
                        commit('SET_USER_MARGIN_ORDER_HISTORY_LIST', result.data.items)
                    } else  {
                        commit('SET_USER_MARGIN_ORDER_HISTORY_LOADING_STATUS', 'error')
                    }
                },
                error => {
                    commit('SET_USER_MARGIN_ORDER_HISTORY_LOADING_STATUS', 'error')
                }
            )
        },
        fetchUserOrders: async ({ commit, getters, dispatch }) => {
            commit('SET_USER_ORDER_LOADING_STATUS', 'loading')
            const {getActiveTool} = getters

            return dispatch("fetchAuth", {
                url: `${url}/order/my-list?status=active&direction=${getActiveTool.direction}`,//`${url}/order/my-list?status=active&direction=${getActiveTool.direction}`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "fetchUserOrders", data: {}}
            }).then(
                result => {
                    if(result.data.items) {
                        commit('SET_USER_ORDER_LOADING_STATUS', 'success')
                        commit('SET_USER_ORDERS', result.data.items)
                    } else  {
                        commit('SET_USER_ORDER_LOADING_STATUS', 'error')
                    }
                },
                error => {
                    commit('SET_USER_ORDER_LOADING_STATUS', 'error')
                }
            )
        },
        makeUserCancelOrder: async ({ commit, dispatch}, hash) => {
            return dispatch("fetchAuth", {
                url: `${url}/order/cancel/${hash}`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "makeUserCancelOrder", data: hash},
            }).then(
                result => {
                    commit('DELETE_USER_ORDER', hash)
                    return result
                },
                error => {
                    throw Error(error.message)
                }
            )
        },
        makeUserMarginCancelOrder: async ({ commit, dispatch}, hash) => {
            return dispatch("fetchAuth", {
                url: `${url}/margin-order/close/${hash}`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "makeUserMarginCancelOrder", data: hash},
            }).then(
                result => {

                    commit('DELETE_USER_MARGIN_ORDER_OPEN', hash)
                    return result
                },
                error => {
                    throw Error(error.message)
                }
            )
        },
        makeUserMarginEditOrder: async ({ commit, dispatch}, data) => {
            const hash = data.hash
            delete data.hash

            return dispatch("fetchAuth", {
                url: `${url}/margin-order/edit/${hash}`,
                option: {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                },
                action: {name: "makeUserMarginEditOrder", data: data},
            }).then(result => {
                if(result.code == 200) {
                    commit('EDIT_USER_MARGIN_ORDER_OPEN', {
                        hash: hash,
                        take_profit: data.take_profit,
                        stop_loss: data.stop_loss
                    });
                }
                return result
            })
        },

        updateMarginTradeMode: async ({ commit, dispatch}, mode) => {
            commit('SET_MARGIN_TRADE_MODE', mode)
        },

    },
    mutations: {
        SET_USER_DIALS(state, dials) {
            state.userDialList = dials
        },
        SET_USER_ORDERS(state, orders) {
            state.userOrderList = orders
        },
        DELETE_USER_ORDER(state, hash) {
            const foundIndex = state.userOrderList.findIndex(e => e.hash === hash)
            if(foundIndex != -1) {
                state.userOrderList.splice(foundIndex, 1);
            }
        },
        SET_USER_MARGIN_ORDER_HISTORY_LIST(state, orders) {
            state.userMarginOrderHistoryList = orders
        },
        SET_USER_MARGIN_ORDER_HISTORY_LOADING_STATUS(state, status) {
            state.userMarginOrderHistoryLoadingStatus = status
        },
        DELETE_USER_MARGIN_ORDER_HISTORY(state, hash) {
            const foundIndex = state.userMarginOrderHistoryList.findIndex(e => e.hash === hash)
            if(foundIndex != -1) {
                state.userMarginOrderHistoryList.splice(foundIndex, 1);
            }
        },
       /* UPDATE_USER_MARGIN_ORDER_OPEN_LIST(state, data) {
            const indexOpen = state.userMarginOrderOpenList.findIndex(e => e.hash == data.hash);
            updateMarginOrder()
            if (indexOpen === -1) {
                addMarginOrder(state, data,'userMarginOrderOpenList');
            }
            state.userMarginOrderOpenList = orders
        },*/
        SET_USER_MARGIN_ORDER_OPEN_LIST(state, orders) {
            state.userMarginOrderOpenList = orders
        },
        SET_USER_MARGIN_ORDER_OPEN_LOADING_STATUS(state, status) {
            state.userMarginOrderOpenLoadingStatus = status
        },
        DELETE_USER_MARGIN_ORDER_OPEN(state, hash) {
            const foundIndex = state.userMarginOrderOpenList.findIndex(e => e.hash === hash)
            if(foundIndex != -1) {
                state.userMarginOrderOpenList.splice(foundIndex, 1);
            }
        },
        EDIT_USER_MARGIN_ORDER_OPEN(state, data) {
            const foundIndex = state.userMarginOrderOpenList.findIndex(e => e.hash === data.hash)
            if(foundIndex != -1) {
                state.userMarginOrderOpenList[foundIndex].take_profit = data.take_profit
                state.userMarginOrderOpenList[foundIndex].stop_loss = data.stop_loss
            }
        },
        SET_USER_DIAL_LOADING_STATUS(state, status) {
            state.userDialLoadingStatus = status
        },
        SET_USER_ORDER_LOADING_STATUS(state, status) {
            state.userOrderLoadingStatus = status
        },
        SET_MARGIN_TRADE_MODE(state, mode) {
            state.marginTradeMode = mode
        },
        SOCKET_ONMESSAGE(state, message) {

            if(message.h === undefined) {
                return
            }
            if(message.s === "bm") {
                updateOrder(state, message, message.h)
                return
            }
            if(message.s === "am") {
                updateDial(state, message, message.h)
                updateOrder(state, message, message.h)
                return
            }
            if(message.s === "cl") {
                deleteOrder(state, state.userOrderList.findIndex(e => e.hash === message.h))
            }
            if(message.t === "mo") {
                handleMarginOrder(state, message, message.h);
            }
        },
    },
    state: {
        userDialList: [],
        userOrderList: [],
        userDialLoadingStatus: 'loading',
        userOrderLoadingStatus: 'loading',
        userMarginOrderHistoryLoadingStatus:  'loading',
        userMarginOrderHistoryList: [],
        userMarginOrderOpenLoadingStatus:  'loading',
        userMarginOrderOpenList: [],
        marginTradeMode: TYPE_CROSS
    },
    getters: {
        getUserDialList:(state) => state.userDialList,
        getUserDialLoadingStatus:(state) => state.userDialLoadingStatus,
        getUserOrderList:(state) => state.userOrderList,
        getUserOrderLoadingStatus:(state) => state.userOrderLoadingStatus,

        getUserMarginOrderHistoryLoadingStatus:(state) => state.userMarginOrderHistoryLoadingStatus,
        getUserMarginOrderHistoryList:(state) => state.userMarginOrderHistoryList,
        getUserMarginOrderOpenLoadingStatus:(state) => state.userMarginOrderOpenLoadingStatus,
        getUserMarginOrderOpenList:(state) => state.userMarginOrderOpenList,
        getMarginTradeMode:(state) => state.marginTradeMode,
    },
}